<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>الخزينة</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>

        <v-dialog
          v-model="add_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-btn slot="activator" color="primary" dark class="mb-2">جديد</v-btn>
          <v-card>
            <v-card-title>
              <span class="headline">اضافة خزينة</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        disabled
                        v-model="mycode"
                        label="كود الخزينة"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.name"
                        label="أسم الخزينة"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_employer"
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر الموظف المسئول"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.rasid"
                        label=" الرصيد"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="newItem.type"
                        label=" النوع"
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.name')"
                        data-vv-name="name"
                        data-vv-scope="form1"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_branch"
                        :items="branches"
                        item-text="name"
                        item-value="id"
                        label="أختر الفرع"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="save('form1')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="edit_dialog"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">تعديل خزينة</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      disabled
                      v-model="editedItem.code"
                      label="كود الخزينة"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.code')"
                      data-vv-name="code"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.name"
                      label="أسم الخزينة"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.name')"
                      data-vv-name="name"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_employer_edit"
                      :items="employers"
                      item-text="name"
                      item-value="id"
                      label="أختر الموظف المسئول"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form1.manger')"
                      data-vv-name="manger"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.rasid"
                      label=" الرصيد"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.name')"
                      data-vv-name="name"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-text-field
                      v-model="editedItem.type"
                      label=" النوع"
                      v-validate="'required'"
                      :error-messages="errors.collect('form2.name')"
                      data-vv-name="name"
                      data-vv-scope="form2"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md4>
                    <v-select
                      v-model="select_branch_edit"
                      :items="branches"
                      item-text="name"
                      item-value="id"
                      label="أختر الفرع"
                      persistent-hint
                      return-object
                      single-line
                      v-validate="'required'"
                      :error-messages="errors.collect('form1.manger')"
                      data-vv-name="manger"
                      data-vv-scope="form1"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click="update('form2')"
                >حفظ</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="khazinas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.emp_resposible_name }}</td>
          <td>{{ props.item.rasid }}</td>
          <td>{{ props.item.type }}</td>

          <td class="justify-center layout px-0">
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              class="ml-4"
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
            <v-icon
              v-if="permissions.delete_all == 1 || user.type == 1"
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import {
  khazinas,
  add_khazina,
  update_khazina,
  delete_khazina,
  branches,
  employers
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: "كود الخزينة",
        align: "right",
        value: "name"
      },
      {
        text: "أسم الخزينة",
        align: "right",
        value: "name"
      },
      { text: "الموظف المسئول", value: "emp_resposible_name", align: "right" },
      { text: "الرصيد", value: "rasid", align: "right" },
      { text: "النوع", value: "type", align: "right" },
      { text: "التحكم", value: "control", sortable: false, align: "center" }
    ],
    select_branch: { id: "" },
    select_branch_edit: { id: "" },
    code: "",
    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    khazinas: [],
    editedItem: {
      id: "",
      code: "",
      name: "",
      emp_resposible_name: "",
      rasid: "",
      type: "",
      branch_id: ""
    },
    newItem: {
      id: "",
      code: "",
      name: "",
      emp_resposible_name: "",
      rasid: "",
      type: "",
      branch_id: ""
    },
    branches: [],
    select_employer: {},
    select_employer_edit: {},
    employers: []
  }),

  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },

    mycode() {
      if (this.khazinas.length > 0) {
        return (this.code =
          parseInt(this.khazinas[this.khazinas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      khazinas().then(response => {
        this.khazinas = response.data;
        this.loading = false;
        this.pagination.totalItems = response.data.length;
      });

      branches().then(response => {
        this.branches = response.data;
      });

      employers().then(response => {
        this.employers = response.data;
      });
    },

    editItem(item) {
      //   this.editedItem = Object.assign({}, item)
      this.editedIndex = this.khazinas.indexOf(item);
      this.editedItem.id = item.id;
      this.editedItem.code = item.code;
      this.editedItem.name = item.name;
      this.editedItem.emp_resposible_name = item.emp_resposible_name;
      this.editedItem.rasid = item.rasid;
      this.editedItem.type = item.type;
      this.editedItem.branch_id = item.branch_id;
      this.select_branch_edit = item.branch;
      this.select_employer_edit = item.employer;
      this.edit_dialog = true;
    },

    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.khazinas.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_khazina(frmData2, item.id).then(response => {
            this.loading = false;
            this.khazinas.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          var frmData = new FormData();
          this.newItem.code = this.code;
          this.newItem.branch_id = this.select_branch.id;
          this.newItem.emp_resposible_name = this.select_employer.name;
          this.newItem.employer_id = this.select_employer.id;
          frmData.append("khazina", JSON.stringify(this.newItem));
          add_khazina(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            this.khazinas.push(response.data);
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
    },

    update(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;

          let item_id = this.editedItem.id;
          this.editedItem.branch_id = this.select_branch_edit.id;
          this.editedItem.emp_resposible_name = this.select_employer_edit.name;
          this.editedItem.employer_id = this.select_employer_edit.id;
          var frmData = new FormData();
          frmData.append("khazina", JSON.stringify(this.editedItem));
          update_khazina(frmData, item_id).then(response => {
            Vue.set(
              this.khazinas,
              this.khazinas.findIndex(f => f.id === item_id),
              response.data
            );
            this.loading = false;
            this.close();
          });
        }
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
